var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{class:[
    'common-btn-wrapper',
    _vm.hasTips ? 'hasTips' : '',
    _vm.type,
    _vm.fissionStyleGame,
  ]},[_c('button',{class:[
      'common-btn',
      _vm.animation ? 'breathing-btn' : '',
      _vm.fissionStyleGame,
    ],on:{"click":_vm.click}},[_c('p',{staticClass:"flex-center"},[_vm._v(_vm._s(_vm.btnText))]),_vm._v(" "),(_vm.hasTips)?_c('popover-tip',{class:['tips', _vm.type],attrs:{"text":_vm.tipsText,"registerAwardsType":_vm.registerAwardsType,"registerAwardsNum":_vm.registerAwardsNum,"couponType":_vm.couponType,"btnType":_vm.btnType,"shareDesc":_vm.shareDesc}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }